import React, {useCallback, useEffect, useState, useContext } from 'react';
import { View, StyleSheet, Image, ImageBackground, Text, TextInput, keyboard, FlatList, TouchableOpacity, Platform } from 'react-native';
import * as ImageManipulator from "expo-image-manipulator"
import * as ImagePicker from "expo-image-picker"
import * as Location from "expo-location";
import colors from '../config/colors';
import { MaterialCommunityIcons, MaterialIcons, Entypo } from "@expo/vector-icons";
import defaultStyles from "../config/styles";
import dateNow from '../utility/dateNow';
import AuthContext from "../auth/context";
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
import ActivityIndicator from '../components/ActivityIndicator';
//import { Notifications } from "expo";
//import { Audio } from "expo-av";
import io from 'socket.io-client'
//import routes from '../navigation/routes';
import { ChatListItem, ListItem, ListItemAccount } from '../components/lists';
//import openMap from 'react-native-open-maps'
//import { WebView } from 'react-native-webview';
import { createMapLink, open } from 'react-native-open-maps'
import { useFocusEffect } from '@react-navigation/native'

var socket
var chatRoom = ''
var room = ''
var typeFileImageAndVideo = ''
var nameDateImageAndVideo = ''
var dateRow = ''
var currentDay = ''
var dateComparation = ''
var textDate = ''
var dif = 0

function ChatScreen({ route, navigation }) {
  const [uploadVisible, setUploadVisible] = useState(false);
  const [items, setItems] = useState([]) // Es para jalar el item---
  const [commentBoxText, setCommentBoxText] = useState('') // para que jale el comentario 
  const [loading, setLoading] = useState(false);
  const [imageUri, setImageUri] = useState('');
  const [maps, setMaps] = useState('')
  const { user, setUser } = useContext(AuthContext);
  const [location, setLocation] = useState(null);
 // const { user } = useAuth();
  const date = dateNow();
  var profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'
  var chatUserId = 0

 
useFocusEffect(
useCallback(() => {
    getLocation();


    //aqui empieza soket
    socket = io(connectionConfig.chatUrl, {
      transports: ['websocket'],
      forceNew: true,
      upgrade: false,
      jsonp: false
    })
    //console.log('soket ->', socket)
    // debugger
    socket.on('chat message', (jBackParams) => {
      console.log('back_room -> ', jBackParams.room, '.. back_msg -> ', jBackParams.msg)
      debugger
      
      //chatRoom = back_room
      // if (back_room === room) {
      getChat()
      // }
      setCommentBoxText('algo')

    })
    validateChatUser()
   }, [])
)

  // useEffect(() => {
  //   getLocation();
  //   setCommentBoxText('algo')
  //   //aqui empieza soket
  //   socket = io(connectionConfig.chatUrl, {
  //     transports: ['websocket'],
  //     forceNew: true,
  //     upgrade: false,
  //     jsonp: false
  //   })
  //   //console.log('soket ->', socket)
  //   // debugger
  //   socket.on('chat message', (jBackParams) => {
  //     console.log('back_room -> ', jBackParams.room, '.. back_msg -> ', jBackParams.msg)
  //     debugger
      
  //     //chatRoom = back_room
  //     // if (back_room === room) {
  //     getChat()
  //     // }
  //   })
  //   validateChatUser()
  // }, [])

  //---------------------------------------------
  //Función que consigue la ubicación 
  //---------------------------------------------
  const getLocation = async () => {
    try {
       debugger
      let { status } = await Location.requestForegroundPermissionsAsync();
      if (status !== 'granted') {
        alert('acceso a la ubicación fue negado')
        return;
      }

      let locationsss = await Location.getCurrentPositionAsync({});
      setLocation(locationsss);
console.log(' location latitud ->', location.longitude)
    //   //-----------------------------------------------
    //  let { status } = await Location.requestForegroundPermissionsAsync();
    //   if (status !== 'granted') {
    //     alert('permiso para ubicaión negado')
    //     return;
    //   }
    //   const {
    //     coords: { latitude, longitude },
    //   } = await Location.getCurrentPositionAsync({})


    //   setLocation({ latitude, longitude });
    //   console.log('latitude ' + location.latitude) 
    } catch (error) {
      console.log(error);
    }
  };
  //Escucha y cacha los mensajes enviados por el back (b, c)
  // socket.on('chat message', (msg) => {
  //       getChatFromEmit()
  // })

  //----------------------------------------
  //Valida si el usuario ya estuvo chateando 
  //----------------------------------------
  const validateChatUser = async () => {
    //debugger
    var post_values = {
      userId1: JSON.parse(user).userId,
      followedChatId1: route.params.item.userId,
      userId2: route.params.item.userId,
      followedChatId2: JSON.parse(user).userId
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/SelecValidateStatusChat/', configurationPost)
      .then(response => response.json())
      .then(response => {
        //debugger
        if (response.data.length === 0) {
          //     insertChatUsersInteraction()  
        } else {
          chatUserId = response.data[0].chatUserId
          getChat()
          //setStatuCshat(1)
        }
      })
      .catch(err => {
        console.log('Insert fixo failed :( review internet service -> /SelecValidateStatusChat/', err)
      })
  }

  //------------------------------------------------------------------------------------------------------------------
  //Valida si el usuario ya estuvo chateando desde el boton del chat*1 Función inicio de la encadenación de servicios.
  //------------------------------------------------------------------------------------------------------------------
  const validateChatUserPress = async () => {
    //debugger
    var post_values = {
      userId1: JSON.parse(user).userId,
      followedChatId1: route.params.item.userId,
      userId2: route.params.item.userId,
      followedChatId2: JSON.parse(user).userId
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/SelecValidateStatusChat/', configurationPost)
      .then(response => response.json())
      .then(response => {
        //debugger
        if (response.data.length === 0) {
          insertChatUsersInteraction()
        } else {
          chatUserId = response.data[0].chatUserId
          insertContainChatUsers()
          //setStatuCshat(1)
        }
      })
      .catch(err => {
        console.log('Insert fixo failed :( review internet service -> /SelecValidateStatusChat/', err)
      })
  }


  //---------------------------------------------
  //Agrega interacción para usuarios en el chat. 
  //---------------------------------------------
  const insertChatUsersInteraction = async () => {
    //debugger
    var post_values = {
      userId: JSON.parse(user).userId,
      followedChatId: route.params.item.userId,
      dateInitialChat: date,
      followerChatId: JSON.parse(user).userId,
      room: 'Room' + '_' + route.params.item.userId + '-' + JSON.parse(user).userId
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/insertChatUsersInteraction/', configurationPost)
      .then(response => response.json())
      .then(response => {
        chatUserId = response.data.insertId
        insertContainChatUsers()
        setCommentBoxText('')
        setLoading(true)
      })
      .catch(err => {
        console.log(':( review internet service /insertChatUsersInteraction/', err)
      })
  }


  //------------------------------------------------------
  //Agrega nuevo contenido de comentario  en el chat. 2 *
  //------------------------------------------------------
  const insertContainChatUsers = async () => {
    // debugger
    //Valida si es imagen o video lo que se eligio
    if (imageUri != '') {
      if (imageUri.includes('.jpg')) {
        typeFileImageAndVideo = 'image/jpeg'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_chatImages.jpg'
      }
      if (imageUri.includes('.png')) {
        typeFileImageAndVideo = 'image/png'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_chatImages.png'
      }
      if (imageUri.includes('.mp4')) {
        typeFileImageAndVideo = 'application/mp4'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_chatImages.mp4'
      }
      if (imageUri.includes('.mov')) {
        typeFileImageAndVideo = 'video/quicktime'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_chatImages.mov'
      }
    }

    var post_values = {
      chatUserId: chatUserId,
      userIdPublisherComment: JSON.parse(user).userId,
      userIdReaderComment: route.params.item.userId,
      contentChatBox: commentBoxText,
      dateContentChat: date,
      pushNotificationToken: route.params.item.pushNotificationToken,
      uriLocation: maps,
      chatImage: nameDateImageAndVideo
    }
    //console.log('pushNotificationToken', JSON.parse(user).userId)
    //console.log('pushNotificationToken', route.params.item.pushNotificationToken)
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/insertContainChatUsers/', configurationPost)
      .then(response => response.json())
      .then(response => {
        // getChat()
        if (imageUri != '') {
          savePhoto()
        }
        getChatFromEmit()
        //soketAction()
        setCommentBoxText('')
        setLoading(true)
      })
      .catch(err => {
        console.log(':( review internet service /insertContainChatUsers/', err)
      })
  }


  //----------------------------------------------------------------------
  //Traer los comentarios de la publicación 4 * Término de la encadenacion
  //----------------------------------------------------------------------
  const getChat = async () => {
    //debugger
    var post_values = {
      chatUserId: chatUserId,
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/SelectContentChat/', configurationPost)
      .then(response => response.json())
      .then(response => {
        //response.data.room
        // soketAction(response.data[0].room)
        console.log('getChat -> ')
        
        if (response.data.length > 0) {
          setItems(response.data)
       //  console.log('items.length -> ', items.length)
          if(items.length > 0){
          dateComparation = items[0].dateContentChat.substring(0, 10).replace('/', '').replace('/', '')
          }
        }
        setLoading(false)
      })
      .catch(err => {
       // console.log('items.length -> ', items.length)
        console.log(':( review internet service /SelectContentChat/', err)
  

      })
  }

  //----------------------------------------------------------------------
  //Traer los comentarios de la publicación 4 * Término de la encadenacion
  //----------------------------------------------------------------------
  const getChatFromEmit = async () => {
    //debugger
    var post_values = {
      chatUserId: chatUserId,
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl + '/SelectContentChat/', configurationPost)
      .then(response => response.json())
      .then(response => {


        room = response.data[0].room
        //Manda la señal para refrescar interacción entre usuarios en el chat. (a, b)
        // console.log('comentBoxtext ->', commentBoxText)
        var chatMessage = commentBoxText
        socket.emit('chat message', { room: room, msg: chatMessage })
        // setStatuCshat(statusChat === 0 ? 1 : 0)
       // console.log('statusChat ->', statusChat)

        setItems(response.data)
        setLoading(false)
      })
      .catch(err => {
        console.log(':( review internet service /SelectContentChat/', err)
      })
  }
  //--------------------------------------------------
  //  Select Image es la función que te permite sacar
  //  la biblioteca de imagenes de tu Cel 
  //--------------------------------------------------
  const selectImage = async () => {
    try {
      var quality = 0;
      if (Platform.OS === 'android') {
        quality = 0.8
      } else {
        quality = 0.4
      }
      const result = await ImagePicker.launchImageLibraryAsync(
        {
          mediaTypes: ImagePicker.MediaTypeOptions.All,
          allowsEditing: false,
          aspect: [4, 3],
          quality: quality,
        }
      );
      if (!result.cancelled)
        setImageUri(result.uri)
    //  console.log('ImageUri -> :)', result.uri)
    } catch (error) {
      console.log("error al leer imagen", error)
    }
  }



  //--------------------------------------------- 
  //Rutina para guardar una foto o video
  //---------------------------------------------
  const savePhoto = async () => {
    let format = 'JPEG'
    //let quality = 0.1
    if (Platform.OS === 'android') {
      quality = 0.5

    } else {
      quality = 0.05
    }
    //debugger
    try {
      const formData = new FormData()
      if (typeFileImageAndVideo === 'image/jpeg' || typeFileImageAndVideo === 'image/png') {
        var x = 0
        const manipResult = await ImageManipulator.manipulateAsync(
          imageUri,
          [],
          { compress: quality, format: ImageManipulator.SaveFormat.JPEG })
        formData.append('photoAndVideo', {
          uri: manipResult.uri,
          type: typeFileImageAndVideo,
          name: nameDateImageAndVideo,
        })
      }
      if (typeFileImageAndVideo === 'application/mp4') {
        formData.append('photoAndVideo', {
          uri: imageUri,
          type: typeFileImageAndVideo,
          name: nameDateImageAndVideo,
        })
      }
      if (typeFileImageAndVideo === 'video/quicktime') {
        formData.append('photoAndVideo', {
          uri: imageUri,
          type: typeFileImageAndVideo,
          name: nameDateImageAndVideo,
        })
      }
      const configurationPost = {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'multipart/form-data'
        },
        body: formData
      }
      // post Para guardar imagen de perfil
      fetch(connectionConfig.apiUrl + '/upload_infoPhotoAndVideo', configurationPost)
        .then(response => response.json())
        .then(response => {
          //debugger
          //setProgress(0.8)
          nameDateImageAndVideo = ''
          setImageUri('')

          if (response.data === 'descarga-> error') {
            console.log("maintennance server descarga-> error /upload_infoPhotoAndVideo", response.data)
          }
        })
        .catch((err) => {
          console.log("maintennance server -> catch /upload_infoPhotoAndVideo", err)
        })
    } catch (error) {
      console.log("maintennance server -> catch Final /upload_infoPhotoAndVideo", error)
    }
  }
//--------------------
//validación de fechas
//--------------------
const compareDate = (itemDate, index) => {
  //debugger
   // console.log(';) entre')
    //Valida cuando no hay nada en la conversación
  if ( items.length !=  0){
    //Valida cuando solo hay un elemento en los mensajes
    if(items.length === 1){
     // items[0].textCut = items[index].dateContentChat.substring(0,11)
        currentDay = date.substring(0, 11).replace('/', '').replace('/', '')
        let firstRow  = items[index].dateContentChat.substring(0,11).replace('/', '').replace('/', '')
        dif = parseInt(currentDay, 10) - parseInt(firstRow, 10)

        if (dif === 0) {
       //   console.log('Hoy - ', dif)
          textDate = 'Hoy'
          items[index].textCut = 'Hoy'
        }
        if (dif === 1) {
       //   console.log('Ayer - ', dif)
          textDate = 'Ayer'
          items[index].textCut = 'Ayer'
        }
        if (dif > 1) {
       //   console.log('fecha - ', dif)
          //textDate = itemDate
          items[index].textCut =  items[index ].dateContentChat.substring(0,11)
    }
    }else{
    dateRow = itemDate.substring(0, 11).replace('/', '').replace('/', '')
    currentDay = date.substring(0, 11).replace('/', '').replace('/', '')
  //  console.log('dateRow - ', dateRow, 'currentDay -', currentDay)
    // compara la fecha para obtener el corte 
    if (dateComparation !== dateRow) {
      if (index > 0){
        let dateBeforeRow = items[index - 1].dateContentChat.substring(0,11).replace('/', '').replace('/', '')
          dif = parseInt(currentDay, 10) - parseInt(dateBeforeRow, 10)
        // obtiene el texto del corte en base a la diferencia en días
        if (dif === 0) {
        //  console.log('Hoy - ', dif)
          textDate = 'Hoy'
          items[index - 1].textCut = 'Hoy'
        }
        if (dif === 1) {
      //    console.log('Ayer - ', dif)
          textDate = 'Ayer'
          items[index - 1].textCut = 'Ayer'
        }
        if (dif > 1) {
       //   console.log('fecha - ', dif)
          //textDate = itemDate
          items[index - 1].textCut =  items[index - 1].dateContentChat.substring(0,11)
        }
      }
    } //else {
      //items[index -1].textCut = ''
     // textDate = ''
      
   // }
    // cuando el indice llega al final del arreglo
    // if (index === items.length === 0){
    //   let latestRow  = items[index].dateContentChat.substring(0,11).replace('/', '').replace('/', '')
    //     dif = parseInt(currentDay, 10) - parseInt(latestRow, 10)
    //   if (dif === 0) {
    //     console.log('Hoy - ', dif)
    //     textDate = 'Hoy'
    //     items[index - 1].textCut = 'Hoy'
    //   }
    //   if (dif === 1) {
    //     console.log('Ayer - ', dif)
    //     textDate = 'Ayer'
    //     items[index - 1].textCut = 'Ayer'
    //   }
    //   if (dif > 1) {
    //     console.log('fecha - ', dif)
    //     //textDate = itemDate
    //     items[index - 1].textCut =  items[index - 1].dateContentChat.substring(0,11)
    //   }
    // //items[0].textCut = items[index].dateContentChat.substring(0,11)
    // }
      if (index === items.length - 1){
        let latestRow  = items[index].dateContentChat.substring(0,11).replace('/', '').replace('/', '')
        dif = parseInt(currentDay, 10) - parseInt(latestRow, 10)
        if (dif === 0) {
          debugger
         // console.log('Hoy - ', dif)
          textDate = 'Hoy'
          items[items.length - 1].textCut = 'Hoy'
        }
        if (dif === 1) {
        //  console.log('Ayer - ', dif)
          textDate = 'Ayer'
          items[items.length - 1].textCut = 'Ayer'
        }
        if (dif > 1) {
       //   console.log('fecha - ', dif)
          //textDate = itemDate
          items[items.length - 1].textCut =  items[items.length - 1].dateContentChat.substring(0,11)
        }
         // items[items.length - 1].textCut = items[index - 1].dateContentChat.substring(0,11)
      }
    }
      //console.log('')
   
  }
    dateComparation = dateRow
  //  console.log('textDate->', textDate)
   // return textDate
}


  return (
    <>
      {/* <View style={styles.container}> */}
      <ImageBackground
        source={require('../assets/fixo1024x1024.png')}
        style={styles.imageBackground}
      >
        {/* <div className="video-responsive">
        <iframe
         width="600" 
         height="500"
          id="gmap_canvas" 
         src=' https://www.google.com/maps/embed?@?api=1&map_action=map&basemap=roadmap&center=19.3666012,-99.1566963&layer=transit'
          //src='https://www.google.com/maps/embed?@?api=1&map_action=map&center=19.3261873,-99.1566962'
          //src='https://www.google.com/maps/embed?@?api=1&map_action=map&center=19.3261873,-99.1566962'
          // src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.521260322283!2d106.8195613507864!3d-6.194741395493371!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f5390917b759%3A0x6b45e67356080477!2sPT%20Kulkul%20Teknologi%20Internasional!5e0!3m2!1sen!2sid!4v1601138221085!5m2!1sen!2sid"
          frameborder="0" 
          scrolling="no" 
          marginheight="0" 
          marginwidth="0">
        </iframe> */}
          {/* <iframe
            width="380"
            height="380"
            src={'http://localhost:19006/'}
            frameBorder="0"
            //allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
           // allowFullScreen
           // title="Embedded youtube"
          /> */}
      {/* </div> */}
       
        <ListItemAccount
          //style={styles.container}
          image={profileUri + route.params.item.userId + '_' + route.params.item.userPhoto}
          subTitle={route.params.item.userName}
          detailsContainerLeft={1}
          onPress={() => {
            alert('hola jejeje ->' + profileUri + route.params.item.userId + '_' + route.params.item.userPhoto)
            console.log('hola jejeje ->', profileUri + route.params.item.userId + '_' + route.params.item.userPhoto)

            // navigation.navigate(routes.FOUND_USER, {item, index})
          }}
        >
        </ListItemAccount>
        {
          items != '' ?
            <FlatList
          data={items}
          keyExtractor={(items) => items.chatUserContainId.toString()}
          inverted={true}

          renderItem={({ item, index }) => (
            <ChatListItem
              //image={profileUri + item.userId + '_' + item.userPhoto}
              contentChatBox={item.contentChatBox}
              dateContentChat={item.dateContentChat}
              displayDate={
                compareDate(item.dateContentChat, index)
              }
              textCut = {item.textCut}
              uriLocation={item.uriLocation}
              detailsContainerLeft={item.userId === JSON.parse(user).userId ? true : false}
              chatImage={item.chatImage}
            // onPress={ () => {
            //      props.navigation.navigate(routes.FOUND_USER, {item})
            //      }} 
            />

            //</ChatListItem>   
          )}>
        </FlatList>
        :
        <Text style={styles.text}>
          Empieza una coversación con {route.params.item.userName}
        </Text>
        }
      
        <ActivityIndicator visible={loading} />
        {
          uploadVisible === true ?
            <View style={styles.containerArchiveIcons}>
              <TouchableOpacity style={styles.image} onPress={selectImage}>
                {imageUri != '' ?
                  <Image style={styles.imagePhoto} source={{ uri: imageUri }} />
                  :
                  <MaterialCommunityIcons
                    //style={styles.image}
                    name="camera"
                    size={35}
                    color={colors.medium}
                  />
                }
              </TouchableOpacity>
              {maps === '' ?
                null
                :
                <Text>algo ruta</Text>
                // <WebView
                //   style={styles.map}
                //   source={{ uri: maps }}>

                // </WebView>

              }
              < Entypo
                onPress={() => {
                  debugger
                  console.log('ejemplo de ->', location.latitude )
                  var mapa1 = { latitude: location.coords.latitude, longitude: location.coords.longitude, mapType:'transit' }
                  // openMap(mapa1)

                  console.log('map console ->',
                    createMapLink(mapa1))
                  setMaps(createMapLink(mapa1))
                }
                }
                name={"location"}
                size={35}
                color={defaultStyles.colors.medium}
                style={styles.iconLeft}
              />
              <MaterialIcons
                onPress={() => {
                  setMaps('')
                  setImageUri('')
                  uploadVisible === false ?
                    setUploadVisible(true)
                    :
                    setUploadVisible(false)
                }}
                name={"cancel"}
                size={35}
                color={defaultStyles.colors.medium}
                style={styles.iconLeft}
              />
            </View>
            :
            null
        }
        <View style={styles.containerSearch}>
          <MaterialCommunityIcons
            onPress={() => {
              setImageUri('')
              setMaps('')
              uploadVisible === false ?
                setUploadVisible(true)
                :
                setUploadVisible(false)
            }}
            name={"paperclip"}
            size={35}
            color={defaultStyles.colors.medium}
            style={styles.iconLeft}
          />
          {/* <PickerChat></PickerChat>                      */}
          <TextInput style={styles.input}
            onChangeText={text => setCommentBoxText(text)}
            placeholder="Comment"
            multiline={true}
            numberOfLines={10}
            value={commentBoxText}
          />
          {
            commentBoxText.trim() === '' ?
              null
              :
              <MaterialCommunityIcons
                onPress={() => validateChatUserPress()}
                name={"upload"}
                size={35}
                color={defaultStyles.colors.medium}
                style={styles.icon}
              />
          }
          {
            imageUri.trim() === '' ?
              null
              :
              <MaterialCommunityIcons
                onPress={() => validateChatUserPress()}
                name={"upload"}
                size={35}
                color={defaultStyles.colors.medium}
                style={styles.icon}
              />
          }
          {
            maps.trim() === '' ?
              null
              :
              <MaterialCommunityIcons
                onPress={() => validateChatUserPress()}
                name={"upload"}
                size={35}
                color={defaultStyles.colors.medium}
                style={styles.icon}
              />
          }
        </View>
      </ImageBackground >
      {/* </View> */}
    </>
  );
}
const styles = StyleSheet.create({
  container: {
    //flex: 1,
    position: 'absolute',

  },
  text:{
    width: '80%',
    //height: '20%',
    textAlign:'center',
    backgroundColor: colors.white,
    //color: colors.white,
    fontSize:20,
    alignSelf: "center",
    borderRadius: 5,
    marginTop: '20%'
  },
  containerSearch: {
    marginTop: "5%",
    flexDirection: "row",
    width: "100%",
    height: "10%"
  },
  containerArchiveIcons: {
    marginTop: "5%",
    flexDirection: "row",
    width: "100%",
    backgroundColor: colors.secondary,
    height: "20%"
  },
  input: {
    borderWidth: 1,
    borderColor: colors.medium,
    paddingLeft: 5,
    borderRadius: 5,
    width: "70%",
    color: colors.medium,
    marginLeft: "2%"
  },
  iconLeft: {
    alignSelf: "center",
    margin: 10,
    width: "10%",
  },
  icon: {
    alignSelf: "center",
    margin: 10,
    width: "10%",
  },
  imageBackground: {
    width: "100%",
    height: "100%"
  },
  imagePhoto: {
    width: 100,
    height: 100,
    alignSelf: "center",
    marginBottom: 20,
    borderRadius: 5,
  },
  map: {
    width: 400,
    height: 400,
    //marginTop:100
  }
})

export default ChatScreen;
